import { defineMessages } from 'react-intl';

export default defineMessages({
  decisionTitle: {
    id: 'recap_page.update.btn_decision',
  },
  courtManagerConfirmationDialogContent: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.content_message',
  },
  reason: {
    id: 'legal-proceedings.risk.dialog.judgement_amount.update_reason',
  },
  validationToastSuccess: {
    id:
      'legal_proceeding_page.judgement_add.income_certificate.validation_toast_success',
  },
  dialogValidationButton: {
    id: 'assignment_dialog.validation_button',
  },
  dialogCancelButton: {
    id: 'assignment_dialog.cancel_button',
  },
});
